// import CountUp from "react-countup";
// import { useInView } from "react-intersection-observer";

// export default function NumbersCounter() {
//   const { ref, inView } = useInView({
//     triggerOnce: false, // Allow multiple triggers
//     threshold: 0.5, // 50% of section visible to trigger
//   });

//   return (
//     <section ref={ref} className="bg-brandRed py-12 mt-[20rem]">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
//         <div>
//           <h2 className="text-4xl font-bold text-white">
//             {inView ? <CountUp end={500} duration={2} /> : "0"}+
//           </h2>
//           <p className="mt-2 text-white">Serving People From 12+ year</p>
//         </div>

//         <div>
//           <h2 className="text-4xl font-bold text-white">
//             {inView ? <CountUp end={120} duration={2} /> : "0"}+
//           </h2>
//           <p className="mt-2 text-white">Lives Transform 10K +</p>
//         </div>

//         <div>
//           <h2 className="text-4xl font-bold text-white">
//             {inView ? <CountUp end={300} duration={2} /> : "0"}+
//           </h2>
//           <p className="mt-2 text-white">Events Organized 500+</p>
//         </div>
//        <div>
//           <h2 className="text-4xl font-bold text-white">
//             {inView ? <CountUp end={300} duration={2} /> : "0"}+
//           </h2>
//           <p className="mt-2 text-white">Active Committee Members 30+</p>
//         </div>

        
//       </div>
//     </section>
//   );
// }
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

export default function NumbersCounter() {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.5,
  });

  return (
    <section ref={ref} className="bg-brandRed py-12 mt-[20rem]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 text-center px-4">
        
        <div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white">
            {inView ? <CountUp end={12} duration={2} /> : "0"}+
          </h2>
          <p className="mt-2 text-lg font-semibold text-white">
            Serving People From Years
          </p>
        </div>

        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white">
            {inView ? <CountUp end={10} duration={2} /> : "0"}K+
          </h2>
          <p className="mt-2 text-lg font-semibold text-white">
            Lives Transformed 
          </p>
        </div>

        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white">
            {inView ? <CountUp end={500} duration={2} /> : "0"}+
          </h2>
          <p className="mt-2 text-lg font-semibold text-white">
            Events Organized 
          </p>
        </div>

        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white">
            {inView ? <CountUp end={30} duration={2} /> : "0"}+
          </h2>
          <p className="mt-2 text-lg font-semibold text-white">
            Active Committee Members 
          </p>
        </div>

        <div>
          <h2 className="text-3xl md:text-5xl font-bold text-white">
            {inView ? <CountUp end={12} duration={2} /> : "0"}+
          </h2>
          <p className="mt-2 text-lg font-semibold text-white">
            12 Mini Marathon
          </p>
        </div>
      </div>
    </section>
  );
}

